__turbopack_context__.v({
  "calendar": "DateField-module-scss-module__XsVQaW__calendar",
  "calendar__button": "DateField-module-scss-module__XsVQaW__calendar__button",
  "calendar__button--previous": "DateField-module-scss-module__XsVQaW__calendar__button--previous",
  "calendar__cell": "DateField-module-scss-module__XsVQaW__calendar__cell",
  "calendar__cell--today": "DateField-module-scss-module__XsVQaW__calendar__cell--today",
  "calendar__grid": "DateField-module-scss-module__XsVQaW__calendar__grid",
  "calendar__header": "DateField-module-scss-module__XsVQaW__calendar__header",
  "calendar__heading": "DateField-module-scss-module__XsVQaW__calendar__heading",
  "date-field__button": "DateField-module-scss-module__XsVQaW__date-field__button",
  "date-field__input": "DateField-module-scss-module__XsVQaW__date-field__input",
  "date-field__input-inner": "DateField-module-scss-module__XsVQaW__date-field__input-inner",
  "date-field__label": "DateField-module-scss-module__XsVQaW__date-field__label",
  "date-field__segment": "DateField-module-scss-module__XsVQaW__date-field__segment",
  "enter": "DateField-module-scss-module__XsVQaW__enter",
  "popover": "DateField-module-scss-module__XsVQaW__popover",
});
